type FilterType = 'number' | 'select' | 'date-range' | 'text';

export interface Filter {
  label: string;
  accessor: string;
  type: FilterType;
  value?: any;
  options?: { label: string; id: string }[];
  onChange?: (value: string) => void;
  color: string;
}

export const ACTIVE_COMPANIES_INITIAL_FILTERS: Filter[] = [
  {
    label: 'Company',
    accessor: 'name',
    type: 'select',
    color: '#21a0a0',
    value: null,
  },
  {
    label: 'CUPS',
    accessor: 'cups',
    type: 'select',
    color: '#21a0a0',
    value: null,
  },
  {
    label: 'Alias',
    accessor: 'alias',
    type: 'select',
    color: '#21a0a0',
    value: null,
  },
];
